const formatNotificationsCount = (unreadNotificationsCount) => {
  return unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount
}

export default formatNotificationsCount
